import React from 'react';
import { RefreshCw, Unlink, CheckCircle2, AlertCircle } from 'lucide-react';
import { PLATFORMS_CONFIG } from "../configs/constant";
import Avatar from '../components/Avatar';

const AccountCard = ({ account, onRefresh, onDisconnect, onReconnect }) => {
    const isConnected = account.status === 'active' || account.status === '1' || account.status === 1;
    const needReauth = account.status === 'reauth';
    const config = JSON.parse(account.config);
    return (
        <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm hover:shadow-md transition group">
            <div className="flex justify-between items-start mb-4">
                <div className="relative">
                    <Avatar src={config.avatar} name={account.account_name || account.platform} className="w-12 h-12 border shadow-sm" />
                    <div className={`absolute -bottom-1 -right-1 w-6 h-6 rounded-lg border-2 border-white flex items-center justify-center text-[10px] text-white ${PLATFORMS_CONFIG[account.platform]?.color || 'bg-gray-500'}`}>
                        <i className={PLATFORMS_CONFIG[account.platform]?.icon}></i>
                    </div>
                </div>

                <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-bold ${isConnected ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'
                    }`}>
                    {isConnected ? <CheckCircle2 size={10} /> : <AlertCircle size={10} />}
                    {isConnected ? 'Active' : 'Inactive'}
                </div>
            </div>

            <h3 className="font-bold text-gray-800 text-base truncate">{account.account_name}</h3>
            <p className="text-gray-400 text-xs mb-5 uppercase tracking-tighter">{account.platform}</p>

            <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                {needReauth && <button
                    onClick={() => onRefresh(account.id)}
                    className="flex-1 flex justify-center items-center gap-1 py-2 bg-red-50 hover:bg-red-100 text-red-600 rounded-lg text-xs font-semibold transition"
                >
                    <RefreshCw size={12} /> Refresh
                </button>
                }
                {!isConnected && <button
                    onClick={() => onReconnect(account.id)}
                    className="flex-1 flex justify-center items-center gap-1 py-2 bg-gray-50 hover:bg-red-50 hover:text-red-600 text-gray-400 rounded-lg text-xs font-semibold transition"
                >
                    <Unlink size={12} /> Reconnect
                </button>}
                {isConnected && <button
                    onClick={() => onDisconnect(account.id)}
                    className="flex-1 flex justify-center items-center gap-1 py-2 bg-gray-50 hover:bg-red-50 hover:text-red-600 text-gray-400 rounded-lg text-xs font-semibold transition"
                >
                    <Unlink size={12} /> Disconnect
                </button>}
            </div>
        </div>
    );
};

export default AccountCard;
